// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"9f0cf6d5","426":"8c02ec1a","493":"9f0cf6d5","525":"942a132b","939":"07fa884e"}[chunkId] + ".chunk.css";
};